import { Star } from 'lucide-react';
import { motion } from 'motion/react';

import { useI18n } from '../../i18n';

export default function HowItWorksSection() {
  const { t } = useI18n();

  const steps = [
    {
      number: 1,
      color: 'bg-emerald-100',
      textColor: 'text-emerald-900',
      ...t.howItWorks.steps.register,
    },
    {
      number: 2,
      color: 'bg-emerald-500',
      textColor: 'text-white',
      ...t.howItWorks.steps.receiveOffers,
    },
    {
      number: 3,
      color: 'bg-emerald-100',
      textColor: 'text-emerald-900',
      ...t.howItWorks.steps.compareChoose,
    },
    {
      number: 4,
      color: 'bg-emerald-500',
      textColor: 'text-white',
      ...t.howItWorks.steps.completeContract,
    },
    {
      number: 5,
      color: 'bg-emerald-100',
      textColor: 'text-emerald-900',
      ...t.howItWorks.steps.receiveService,
    },
  ];

  return (
    <motion.section
      id="how-it-works"
      className="relative overflow-hidden bg-white px-4 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <div className="relative z-10">
        <motion.div
          className="mb-10 text-center"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <motion.div
            className="flex flex-col items-center justify-center gap-6"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl">
              {t.howItWorks.title}
            </h2>
            <motion.div
              className="mx-auto h-1 w-full max-w-4xl bg-emerald-500"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
            />
          </motion.div>
        </motion.div>

        <div className="mx-auto max-w-3xl">
          <div className="relative">
            <div className="absolute start-8 top-0 bottom-0 w-1 bg-emerald-500 sm:start-10" />

            <div className="flex flex-col gap-6">
              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  className="relative flex items-start gap-4 sm:gap-6"
                  initial={{ x: -50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{
                    delay: 0.2 + index * 0.15,
                    duration: 0.6,
                    ease: 'easeOut',
                  }}
                  viewport={{ once: true }}
                >
                  <div
                    className={`relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-lg text-2xl font-bold sm:h-20 sm:w-20 sm:text-3xl ${step.color} ${step.textColor}`}
                  >
                    {step.number}
                  </div>

                  <div className="flex flex-1 flex-col justify-center pt-2">
                    <h3 className="text-lg font-bold text-[#00a633] sm:text-xl">
                      {step.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-gray-600 sm:text-base">
                      {step.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
